import { GET_SALEORDERFORMDATA_SUCCESS, GET_SALEORDERFORMDATA_REQUEST, GET_SALEORDERFORMDATA_ERROR } from "../actions/types";
export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_SALEORDERFORMDATA_REQUEST:
			return {
				loading: true,
			};
		case GET_SALEORDERFORMDATA_SUCCESS:
			return {
				...state,
				loading: false,
				payload,
			};
		case GET_SALEORDERFORMDATA_ERROR:
			return {
				...state,
				loading: false,
			};
		default:
			return state;
	}
}
